<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-heading mb-4">Händler bearbeiten </h4>
            <b-form-group label-cols="3" label="Name">
                <b-form-input
                    v-model="name"
                    size="md"
                    class="">
                </b-form-input>
            </b-form-group>
						<b-form-group label-cols="3" label="Kurzform">
							<b-form-input
									v-model="shortForm"
									size="md"
									class="">
							</b-form-input>
						</b-form-group>
            <b-form-group label-cols="3" label="Strafertrag">
              <b-input-group append="€" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input v-model="incomeFine" id="inline-form-input-username" ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group label-cols="3" label="Versandgruppe">
              <b-form-select
                v-model="selectedDeliveryGroup"
                :options="sortedGroups"
                size="md"
                class="mb-2 mr-sm-2 mb-sm-0"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="Lieferklasse">
              <b-form-select
                  v-model="selectedDeliveryClass"
                  :options="deliveryClasses"
                  size="md"
                  class="mb-2 mr-sm-2 mb-sm-0"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="SKU Prefix">
              <b-form-input
                  v-model="vendor.skuPrefix"
                  size="md"
                  disabled
                  class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Land">
              <b-form-select
                  v-model="selectedCountry"
                  :options="countries"
                  size="md"
                  class="mb-2 mr-sm-2 mb-sm-0"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="Währung">
              <b-form-select
                  v-model="selectedCurrency"
                  :options="currencies"
                  size="md"
                  class="mb-2 mr-sm-2 mb-sm-0"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="Händleradresse (Export)">
              <b-form-select
                  v-model="selectedAddress"
                  :options="addresses"
                  size="md"
                  class="mb-2 mr-sm-2 mb-sm-0"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label="Hauptlieferant">
              <b-form-select
                  v-model="selectedMainVendor"
                  :options="mainVendors"
                  size="md"
                  class="mb-2 mr-sm-2 mb-sm-0"
              ></b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" class="" label="Handlingtime">
              <b-input-group  append="Tage" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input v-model="handlingTime" id="inline-form-input-username" ></b-form-input>
              </b-input-group>
            </b-form-group>
              <div class="w-100 d-flex">
                <div class="col-6 pl-0">
                  <b-form-group label-cols="6" class="" label="Hat echte Stocks">
										<div class="form-check">
											<input
													id="chk-has-real-stocks"
													type="checkbox"
													class="form-check-input checkbox-blue"
													v-model="hasRealStocks"
													:true-value="1"
													:false-value="0"
											>
										</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label-cols="7" class="" label="Hat virtuelle Stocks">
										<div class="form-check">
											<input
													id="chk-has-virtual-stocks"
													type="checkbox"
													class="form-check-input checkbox-blue"
													v-model="hasVirtualStocks"
													:true-value="1"
													:false-value="0"
											>
										</div>
                  </b-form-group>
                </div>
              </div>
            <div class="w-100 d-flex">
              <div class="col-6 pl-0">
                  <b-form-group label-cols="6" class="" label="Wareneingang aktiv">
										<div class="form-check">
											<input
													id="chk-delivery-note-active"
													type="checkbox"
													class="form-check-input checkbox-blue"
													v-model="deliveryNoteActive"
													:true-value="1"
													:false-value="0"
											>
										</div>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label-cols="7" class="" label="Lieferscheine automatisch abschließen">
										<div class="form-check">
											<input
													id="chk-autocomplete-delivery-notes"
													type="checkbox"
													class="form-check-input checkbox-blue"
													v-model="autocompleteDeliveryNotes"
													:true-value="1"
													:false-value="0"
											>
										</div>
                  </b-form-group>
                </div>
              </div>
            <div class="w-100 d-flex">
              <div class="col-6 pl-0">
                <b-form-group label-cols="6" class="flex-nowrap" label="Aktiv">
									<div class="form-check">
										<input
												id="chk-active"
												type="checkbox"
												class="form-check-input checkbox-blue"
												v-model="isActive"
												:true-value="1"
												:false-value="0"
										>
									</div>
                </b-form-group>
              </div>
            </div>
            <b-btn variant="primary" class="float-right" @click="updateVendor()">Speichern</b-btn>
          </div>
        </div>
      </div>
    </div>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  name: "VendorEdit",
  props: {
    vendor: {
      type: Object,
      required: true
    },
    deliveryGroups: {
      type: Object,
      required: true
    },
    deliveryClasses: {
      type: Object,
      required: true
    },
    countries: {
      type: Object,
      required: true
    },
    currencies: {
      type: Object,
      required: true
    },
    addresses: {
      type: Object,
      required: true
    },
    mainVendors: {
      type: Object,
      required: true
    }
  },
  data(){
    return{
      name: "",
      shortForm: "",
      incomeFine: "",
      handlingTime: "",
      selectedDeliveryGroup: null,
      selectedDeliveryClass: null,
      selectedCountry: null,
      selectedCurrency: null,
      selectedMainVendor: null,
      selectedAddress: null,
      hasRealStocks: 0,
      hasVirtualStocks: 0,
      deliveryNoteActive: 0,
      autocompleteDeliveryNotes: 0,
      isActive: 0,
      originalValues: {},
      modalError: {
        show: false,
        message: '',
        error: '',
        title: ''
      },
    }
  },
  methods: {
    updateVendor() {
      const payload = {
        name: this.name,
        shortForm: this.shortForm,
        incomeFine: this.incomeFine,
        deliveryGroupId: this.selectedDeliveryGroup,
        deliveryClass: this.selectedDeliveryClass,
        countryId: this.selectedCountry,
        currencyId: this.selectedCurrency === -1 ? null : this.selectedCurrency,
        mainVendorId: this.selectedMainVendor === "Kein Hauptlieferant ausgewählt" ? null : this.selectedMainVendor,
        addressId: this.selectedAddress === "Keine Adresse eingetragen" ? null : this.selectedAddress,
        handlingTime: this.handlingTime,
        hasRealStocks: this.hasRealStocks,
        hasVirtualStocks: this.hasVirtualStocks,
        deliveryNoteActive: this.deliveryNoteActive,
        autocompleteDeliveryNotes: this.autocompleteDeliveryNotes,
        isActive: this.isActive,
        originalValues: this.originalValues
      }

      axios.put("/vendor/" + this.vendor.id, payload)
      .then(response => {
        console.log(response);
        this.$bvToast.toast('Änderungen wurden erfolgreich bearbeitet', {
          title : "Update erfolgreich",
          variant : "success",
          autoHideDelay: 5000,
        })
      })
      .catch(error => {
        console.log(error);
        this.modalError = {
          show: true,
          message: 'Ein Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.response?.data ??  error.message ?? error,
          title: 'Update fehlgeschlagen'
        };
      });
    }
  },
	computed: {
		sortedGroups() {
			const entries = Object.entries(this.deliveryGroups)
					.map(([id, name]) => ({ value: id, text: name }));

			//Separate the placeholder
			const placeholder = entries.find(item => item.value === "");
			const realData = entries.filter(item => item.value !== "");

			realData.sort((a, b) => a.text.localeCompare(b.text));

			return placeholder ? [placeholder, ...realData] : realData;
		}
	},
  created() {
    this.name = this.vendor.name;
    this.shortForm = this.vendor.shortForm;
    this.incomeFine = this.vendor.incomeFine;
    this.selectedDeliveryGroup = this.vendor.deliveryGroupId;
    this.selectedDeliveryClass = this.vendor.deliveryClass;
    this.selectedCountry = this.vendor.countryId;
    this.selectedCurrency = this.vendor.currencyId ?? -1;
    this.selectedMainVendor = this.vendor.mainVendorId ?? this.mainVendors[""];
    this.selectedAddress = this.vendor.addressId ?? this.addresses[""];
    this.handlingTime = this.vendor.handlingTime;
    this.hasRealStocks = this.vendor.hasRealStocks;
    this.hasVirtualStocks = this.vendor.hasVirtualStocks;
    this.deliveryNoteActive = this.vendor.deliveryNoteActive;
    this.autocompleteDeliveryNotes = this.vendor.autocompleteDeliveryNotes;
    this.isActive = this.vendor.isActive;

    //used for recomputation
    this.originalValues = {
    	id: this.vendor.id,
      name: this.vendor.name,
      shortForm: this.vendor.shortForm,
      incomeFine: this.vendor.incomeFine,
      deliveryGroupId: this.vendor.deliveryGroupId,
      deliveryClass: this.vendor.deliveryClass,
      countryId: this.vendor.countryId,
      currencyId: this.vendor.currencyId,
      mainVendorId: this.vendor.mainVendorId,
      addressId: this.vendor.addressId,
      handlingTime: this.vendor.handlingTime,
      hasRealStocks: this.vendor.hasRealStocks,
      hasVirtualStocks: this.vendor.hasVirtualStocks,
      deliveryNoteActive: this.vendor.deliveryNoteActive,
      autocompleteDeliveryNotes: this.vendor.autocompleteDeliveryNotes,
      isActive: this.vendor.isActive
    }
  }
}
</script>
<style scoped>
.checkbox-blue { accent-color: #007bff; }

</style>